import withWidth from '@material-ui/core/withWidth'
import PropTypes from 'prop-types'
import React from 'react'

import BuyBigModal from '../../buy/dumb/BuyBigModal'

const CouponHelperModal = ({ display, onClose, content }) => (
  <BuyBigModal
    display={display}
    h4="Codice coupon o promozionale"
    onClose={onClose}
  >
    {content}
  </BuyBigModal>
)

CouponHelperModal.defaultProps = {
  onClose: () => {},
  display: false,
  content: null,
}

CouponHelperModal.propTypes = {
  content: PropTypes.element,
  display: PropTypes.bool,
  onClose: PropTypes.func,
}

export default withWidth()(CouponHelperModal)
